
import universal, { setHasBabelPlugin } from '/opt/letsplay/famsch/default/node_modules/react-universal-component/dist/index.js'


setHasBabelPlugin()

const universalOptions = {
  loading: () => null,
  error: props => {
    console.error(props.error);
    return <div>An error occurred loading this page's template. More information is available in the console.</div>;
  },
}

const t_0 = universal(import('../src/pages/404.js'), universalOptions)
const t_1 = universal(import('../src/pages/about.js'), universalOptions)
const t_2 = universal(import('../src/pages/blog.js'), universalOptions)
const t_3 = universal(import('../src/containers/Post'), universalOptions)
const t_4 = universal(import('../src/pages/echaton.js'), universalOptions)
const t_5 = universal(import('../src/pages/index.js'), universalOptions)
const t_6 = universal(import('../src/pages/mahjongg.js'), universalOptions)
const t_7 = universal(import('../src/pages/ritchy.js'), universalOptions)
const t_8 = universal(import('../src/pages/sudoku.js'), universalOptions)


// Template Map
export default {
  '../src/pages/404.js': t_0,
'../src/pages/about.js': t_1,
'../src/pages/blog.js': t_2,
'../src/containers/Post': t_3,
'../src/pages/echaton.js': t_4,
'../src/pages/index.js': t_5,
'../src/pages/mahjongg.js': t_6,
'../src/pages/ritchy.js': t_7,
'../src/pages/sudoku.js': t_8
}

export const notFoundTemplate = "../src/pages/404.js"
